import React from 'react';
import { MenuItem, Pagination, Select } from '@mui/material';
import classNames from 'classnames';
import styles from './PaginationControls.module.scss';

interface PaginationControlsProps {
  page: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  disabled?: boolean;
}

const pageSizeOptions = [10, 20, 50, 100];

const PaginationControls: React.FC<PaginationControlsProps> = ({
  page,
  pageSize,
  totalElements,
  totalPages,
  onPageChange,
  onPageSizeChange,
  disabled,
}) => {
  if (totalElements === 0) return null;

  const start = page * pageSize + 1;
  const end = Math.min((page + 1) * pageSize, totalElements);

  return (
    <div className={styles.paginationControls}>
      <div
        className={classNames(styles.summary, {
          [styles.disabledSummary]: disabled,
        })}
      >
        {start}-{end} of {totalElements}
      </div>
      <Pagination
        count={Math.max(totalPages, 1)}
        page={page + 1}
        onChange={(_, value) => onPageChange(value - 1)}
        disabled={disabled}
        size="small"
        color="primary"
      />
      <Select
        className={classNames(styles.pageSize, {
          [styles.disabledPageSize]: disabled,
        })}
        size="small"
        value={pageSize}
        onChange={(event) => onPageSizeChange(Number(event.target.value))}
        disabled={disabled}
      >
        {pageSizeOptions.map((option) => (
          <MenuItem key={option} value={option}>
            {option} / page
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

export default PaginationControls;
